import { useEffect, useMemo, useRef, useState } from 'react';

import {
    Box,
    Button,
    Card,
    Collapse,
    Divider,
    Flex,
    Heading,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    Text,
    useBreakpointValue
} from '@chakra-ui/react';

import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";

export function RegPayPalDisplay({eventConfig, requestActive, disabledCriteria, badgeCost, requestType, scheduleParams, buyBadge, recordBadge}) {
    
    const style = {"layout":"vertical"};

    const paypalDisplay = useMemo(()=> {
        return (
            <PayPalScriptProvider 
                options={{
                    clientId: eventConfig["payPalClientId"],
                    components: "buttons",
                    currency: "USD"
                }}
            >
                <PayPalButtons
                    style={style}
                    disabled={disabledCriteria}
                    forceReRender={[style]}
                    fundingSource={undefined}
                    createOrder={(data, actions) => buyBadge(data, actions, requestType, scheduleParams)}
                    onApprove={(data, actions) => recordBadge(data, actions, requestType, scheduleParams)}
                />
            </PayPalScriptProvider>
        );
    }, [disabledCriteria, badgeCost])

    try {
        return (
            <>
                <Heading align="center" size="xl" mb={4}>${badgeCost}.00 to register</Heading>
                <Flex mb={4} flexDirection="column" flexFlow="wrap" gap={3} alignItems="center" justifyContent="space-evenly">
                    <Box flex="1 100%" maxWidth={{base: "300px", xl: "650px"}} padding={4} ml="auto" mr="auto" borderRadius={8} bgColor="white">
                        {paypalDisplay}
                    </Box>
                </Flex>
            </>
        );
    } catch (e) {
        console.error("RegPayPalDisplay render error: ", e);
    }
}